import { Dispatch } from 'redux';
import {
  NAV_CONTENT,
  NAV_CONTENT_FAILED,
  NAV_CONTENT_SUCCESS,
  MEDICAL_QUESTIONNAIRE,
  MEDICAL_QUESTIONNAIRE_FAILED,
  MEDICAL_QUESTIONNAIRE_SUCCESS,
  NEED_ANALYSIS_QUESTIONNAIRE,
  NEED_ANALYSIS_QUESTIONNAIRE_SUCCESS,
  NEED_ANALYSIS_QUESTIONNAIRE_FAILED
} from './types';
import { ReduxStore } from '../payload-types';
import { ApiClient } from '../api.client';
import { get, toUpper } from 'lodash';
import { traverseAndUpdate, mapOrganizationNameContent } from '../utils';
import { LINKS, LOGIN_ROUTES, NEED_ANALYSIS_QUERY, PLAN_CLASS } from '@trip-ux/constants';
import axios from 'axios';
import { CIAM_LOGIN_SUCCESS } from '../adfs';
import { GET_CLAIMS_FAILED, GET_CLAIMS_SUCCESS, SET_USER } from '../user-profile';

export const getNavContent =
  () =>
  async (dispatch: Dispatch, getState: () => ReduxStore, apiClient: ApiClient): Promise<unknown> => {
    dispatch({ type: NAV_CONTENT });

    const { loginPending, tokenPending } = getState().adfsAuth;

    if (!loginPending && !tokenPending) {
      try {
        const response = await axios.get(LOGIN_ROUTES.AUTH_GET_USER);
        const { user, claims } = response.data;
        dispatch({ type: SET_USER, payload: user });
        dispatch({ type: GET_CLAIMS_SUCCESS, payload: { claims: claims, user: user } });
        dispatch({ type: CIAM_LOGIN_SUCCESS });
      } catch (error) {
        dispatch({ type: GET_CLAIMS_FAILED, payload: error });
      }
    }

    const { config, userProfile } = getState();
    return apiClient(dispatch, getState)
      .post(
        LINKS.CONTENT,
        {
          organizationCode: userProfile.organizationCode || config.options.organizationCode,
          lang: toUpper(config.locale),
          salesChannel: toUpper(config.options.salesChannel)
        },
        { withCredentials: true }
      )
      .then(({ data }) =>
        dispatch({
          type: NAV_CONTENT_SUCCESS,
          payload: {
            ...mapOrganizationNameContent(
              traverseAndUpdate(data, config.options.aemRegex, config.options.contextPath, location.search),
              config.locale
            )
          }
        })
      )
      .catch(e => dispatch({ type: NAV_CONTENT_FAILED, payload: e }));
  };

export const getMedicalQuestionnaire =
  (planClass: string, date: Date, language: string) =>
  (dispatch: Dispatch, getState: () => ReduxStore, apiClient: ApiClient): Promise<unknown> => {
    dispatch({ type: MEDICAL_QUESTIONNAIRE });
    const config = getState().config;
    const isAdmin = get(config, 'isAdmin');
    planClass = toUpper(planClass);
    const salesChannel = toUpper(get(config, 'options.salesChannel'));
    const mqLIAScripting = isAdmin ? true : false;
    const organizationCode = getState().userProfile.organizationCode || config.options.organizationCode;
    return apiClient(dispatch, getState)
      .get(LINKS.MEDICALQUESTIONNAIRE, {
        params: { planClass, date, language, salesChannel, mqLIAScripting, organizationCode }
      })
      .then(res => {
        const organization = get(res, 'organization');
        let medicalQuestionaire = {};
        medicalQuestionaire = get(res, 'medicalQuestionnaireData');
        dispatch({
          type: MEDICAL_QUESTIONNAIRE_SUCCESS,
          payload: { ...medicalQuestionaire, planClass, date, language, salesChannel, mqLIAScripting, organization }
        });
      })
      .catch(e => dispatch({ type: MEDICAL_QUESTIONNAIRE_FAILED, payload: e }));
  };

export const getNAQuestionnaire =
  (effectiveDate: string, lang: string) =>
  (dispatch: Dispatch, getState: () => ReduxStore, apiClient: ApiClient): Promise<unknown> => {
    dispatch({ type: NEED_ANALYSIS_QUESTIONNAIRE });
    return apiClient(dispatch, getState)
      .post(LINKS.GRAPHQL, {
        query: NEED_ANALYSIS_QUERY,
        variables: { planClass: PLAN_CLASS.NAQC, effectiveDate, lang }
      })
      .then(({ data }) => {
        dispatch({
          type: NEED_ANALYSIS_QUESTIONNAIRE_SUCCESS,
          payload: { ...get(data, 'medicalQuestionnaire'), planClass: PLAN_CLASS.NAQC, effectiveDate, lang }
        });
      })
      .catch(e => dispatch({ type: NEED_ANALYSIS_QUESTIONNAIRE_FAILED, payload: e }));
  };
